import React, { useState } from "react";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";

// Register necessary components for Chart.js
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const Download = () => {
    const [timePeriod, setTimePeriod] = useState("Days"); // Default to 'Days'

    // Data for each time period (Days, Month, Year)
    const data = {
        Days: {
            labels: ["Content Resource", "Content Resource", "Content Resource", "Content Resource", "Content Resource", "Content Resource", "Content Resource"],
            datasets: [
                {
                    data: [2600, 4400, 1200, 2400, 2300, 3500, 4700],
                    backgroundColor: "#AC4290",
                    borderRadius: 12, // Apply circular corners to the bars
                },
            ],
        },
        Month: {
            labels: ["Week 1", "Week 2", "Week 3", "Week 4"],
            datasets: [
                {
                    data: [1200, 1500, 1250, 1600],
                    backgroundColor: "#AC4290",
                    borderRadius: 12, // Apply circular corners to the bars
                },
            ],
        },
        Year: {
            labels: ["Q1", "Q2", "Q3", "Q4"],
            datasets: [
                {
                    data: [1000, 1000, 1500, 2000],
                    backgroundColor: "#AC4290",
                    borderRadius: 12, // Apply circular corners to the bars
                },
            ],
        },
    };

    const options = {
        responsive: true,
        plugins: {
            tooltip: {
                enabled: true, // ❌ Turn off tooltip if you also don't want hover values
            },
            datalabels: {
                display: false, // ⛔ Explicitly disable data labels if plugin is registered
            },
        },

        scales: {
            x: {
                ticks: {
                    // X-axis label options
                    color: '#000', // text color
                    font: {
                        size: 10,
                    },
                    padding: 8,
                    callback: function (value, index, ticks) {
                        const label = this.getLabelForValue(value);
                        // Example: break on space
                        return label.split(" ");  // Or return ['Line 1', 'Line 2']
                    },
                },
            },
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 1000,
                    callback: (value) => (value >= 1000 ? value / 1000 + "k" : value),
                },
            },
        },
    };

    // Function to handle time period changes (Days, Month, Year)
    const handleTimePeriodChange = (period) => {
        setTimePeriod(period);
    };

    return (
        <div className="download-chart-container">
            <div className="download-chart-header">
                <div className="download-time-toggle">
                    {["Days", "Month", "Year"].map(period => (
                        <button
                            key={period}
                            onClick={() => setTimePeriod(period)}
                            className={timePeriod === period ? "active" : ""}
                        >
                            {period}
                        </button>
                    ))}
                </div>
            </div>

            <div className="">
                <Bar data={data[timePeriod]} options={options} />
            </div>
        </div>
    );
};

export default Download;
